import { AppState } from '@redux/reducers';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import notFound404Cord from '@assets/svg/404cord.svg';
import notFoundCord from '@assets/svg/Cord.svg';
import { Button } from '@mui/material';
import { ColumnLayout } from '@components/Layout/ColumnLayout/ColumnLayout';
import { ColumnLayoutContent } from '@components/Layout/ColumnLayout/ColumnLayoutContent';

type NotFoundProps = {
  onButtonClick: () => void;
};

export function NotLoggedInNotFoundImg() {
  return (
    <div className="column gap">
      <img src={notFoundCord} alt="detached power plug" />
    </div>
  );
}

export function LoggedInNotFoundImg() {
  return (
    <div className="column gap">
      <img src={notFound404Cord} alt="detached power plug making 404 text with it's cord" />
    </div>
  );
}

const NotLoggedInNotFound: React.FC<NotFoundProps> = ({ onButtonClick }) => {
  const { translations, translate } = useTranslations();
  const tr = translations.notFound;
  return (
    <div className="column gap">
      <h2>{translate(tr.notAccess)}</h2>
      <Button variant="contained" onClick={onButtonClick}>
        {translate(tr.toTheLoginButton)}
      </Button>
    </div>
  );
};

const LoggedInNotFound: React.FC<NotFoundProps> = ({ onButtonClick }) => {
  const { translations, translate } = useTranslations();
  const tr = translations.notFound;
  return (
    <div className="column gap">
      <h2>{translate(tr.goToInboxLabel)}</h2>
      <Button variant="contained" onClick={onButtonClick}>
        {translate(tr.toTheInboxButton)}
      </Button>
    </div>
  );
};

export function NotFound() {
  const { translations, translate } = useTranslations();
  const tr = translations.notFound;
  const loggedInUserId = useSelector<AppState, number | null>((state) => state.User.userId);
  const navigate = useNavigate();

  const onButtonClick = useCallback(
    (targetPath: string) => () => {
      navigate(targetPath);
    },
    [navigate],
  );

  return (
    <ColumnLayout list={[]} title={``}>
      <ColumnLayoutContent isOpen>
        <div className="wrapper-box column align-center gap">
          {loggedInUserId ? (
            <>
              <LoggedInNotFoundImg />
              <h1 className="bold">{translate(tr.siteNotFound)}</h1>
              <LoggedInNotFound onButtonClick={onButtonClick(`/leads`)} />
            </>
          ) : (
            <>
              <NotLoggedInNotFoundImg />
              <h1 className="bold">{translate(tr.somethingWentWrong)}</h1>
              <NotLoggedInNotFound onButtonClick={onButtonClick(`/login`)} />
            </>
          )}
        </div>
      </ColumnLayoutContent>
    </ColumnLayout>
  );
}
